import { render, staticRenderFns } from "./ProofEmailTeam.vue?vue&type=template&id=00482fbe"
import script from "./ProofEmailTeam.vue?vue&type=script&lang=js"
export * from "./ProofEmailTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports